import { render, staticRenderFns } from "./RegionChooser.vue?vue&type=template&id=77e1eac8&"
import script from "./RegionChooser.vue?vue&type=script&lang=js&"
export * from "./RegionChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports